import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import store from "./reduxStore";
import "./theme/global.scss";

ReactDOM.render(
  <Provider store={store}>
    <div className="wrapper">
      <App />
    </div>
  </Provider>,
  document.getElementById("root")
);
